export enum DialogResultType {
  Cancel = 'Cancel',
  Update = 'Update',
  Add = 'Add',
  Preferred = 'Preferred',
  Error = 'Error',
}
